<template>
  <div :style="themeCss">
    <div id="aw--c">
      <div id="aw-sl">
        <div class="wc" v-if="webinarInfo != undefined">
          <InfoTab :info="webinarInfo" v-if="webinarInfo.is_info_tab_visible" />
          <FullVideoCompoment
            v-if="
              webinarInfo.is_full_video_visible &&
              webinarInfo.is_full_video_on_top
            "
            :fullvideo="webinarInfo.video_urls"
            :show-head="webinarInfo.moments.length > 0"
            :duration="webinarInfo.duration"
            :webid="webinarInfo.id"
            :subtitleUrls="webinarInfo.subtitle_urls"
            :subtitles="webinarInfo.subtitles"
          />
          <div id="moment-container" class="row" style="align-content: center">
            <div id="aw-tc" v-if="webinarInfo.moments.length > 0">
              <div class="cl" />
              <ul>
                <li
                  class="tc"
                  v-for="(m, i) in webinarInfo.moments"
                  :key="i"
                  :id="'moment-' + m.id"
                >
                  <div
                    id="cl-m"
                    :class="[i % 2 == 0 ? 'l-d' : 'r-d']"
                    style="position: relative"
                  />
                  <div :class="[i % 2 == 0 ? 'cl-m-lside' : 'cl-m-rside']" />
                  <div class="rnd-crns">
                    <VideoPlayer
                      v-if="
                        !m.video_urls.iframe_url ||
                        m.video_urls.iframe_url == ''
                      "
                      :video_urls="m.video_urls"
                      :duration="m.duration"
                      :mid="m.id"
                      :subtitleUrls="m.subtitle_urls"
                      :subtitles="m.subtitles"
                      :continuefromTime="m.end_time"
                      :videoType="VideoType.Moment"
                    />
                    <IframeVideoPlayer
                      v-else
                      :iframe_url="m.video_urls.iframe_url"
                      :poster="m.video_urls.poster_url"
                      :duration="m.duration"
                    />
                  </div>
                  <p v-html="m.title" class="mom-t" v-if="m.title" />
                  <div v-html="m.description" class="mom-d" />
                  <ShareNetwork
                    network="linkedin"
                    :url="`${socialShareUrl}m${m.id}`"
                    :title="m.title ?? ''"
                    :description="m.description ?? ''"
                    v-if="
                      !!webinarInfo.share_buttons &&
                      !!webinarInfo.share_buttons.linkedin
                    "
                    style="display: inline-block !important"
                    class="aw-ssi"
                    @open="registerSocialShare(m.id)"
                  >
                    <i class="fa fa-linkedin" />
                    <img :src="require('@/assets/icons/linkedin-icon.png')" />
                  </ShareNetwork>
                  <ShareNetwork
                    network="twitter"
                    :url="`${socialShareUrl}m${m.id}`"
                    :title="m.title ?? ''"
                    :description="m.description ?? ''"
                    v-if="
                      !!webinarInfo.share_buttons &&
                      !!webinarInfo.share_buttons.twitter
                    "
                    style="display: inline-block !important"
                    class="aw-ssi"
                    @open="registerSocialShare(m.id)"
                  >
                    <i class="fa fa-twitter" />
                    <img :src="require('@/assets/icons/twitter-icon.png')" />
                  </ShareNetwork>
                  <ShareNetwork
                    network="facebook"
                    :url="socialShareUrl + 'm' + m.id"
                    :title="m.title ?? ''"
                    :description="m.description ?? ''"
                    v-if="
                      !!webinarInfo.share_buttons &&
                      !!webinarInfo.share_buttons.facebook
                    "
                    style="display: inline-block !important"
                    class="aw-ssi"
                    @open="registerSocialShare(m.id)"
                  >
                    <i class="fa fa-facebook" />
                    <img :src="require('@/assets/icons/facebook-icon.png')" />
                  </ShareNetwork>
                </li>
              </ul>
              <div class="vl" />
            </div>
          </div>
          <div style="margin-top: 40px">
            <FullVideoCompoment
              v-if="
                webinarInfo.is_full_video_visible &&
                !webinarInfo.is_full_video_on_top
              "
              :fullvideo="webinarInfo.video_urls"
              :show-head="webinarInfo.moments.length > 0"
              :duration="webinarInfo.duration"
              :webid="webinarInfo.id"
              :subtitleUrls="webinarInfo.subtitle_urls"
              :subtitles="webinarInfo.subtitles"
            />
          </div>
        </div>
        <div v-else>
          {{ loadingmsg }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { WebinarDataService } from "@/services/WebinarDataServices"
import { WebinarInfo } from "@/models/WebinarInfo"
import "@/assets/_base.scss"
import { AwEventType } from "@/models/AwEventType"
import { AwEventStore } from "@/models/AwEventStore"
import setThemeData from "@/services/setThemeData"
import Color from "@/services/Color"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { container } from "tsyringe"
import { getFullVideo } from "@/services/getFullVideoData"
import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref
} from "@vue/runtime-core"
import injectStrict from "@/utils/injectStrict"
import { GlobalDataKey, LoggerKey } from "@/symbols"
import VideoPlayer from "@/components/shared/Player.vue"
import InfoTab from "@/components/shared/InfoTab.vue"
import "@/assets/timeline.scss"
import FullVideoCompoment from "@/components/shared/FullVideoComponent.vue"
import { focusOnMoment } from "@/services/momentFocusService"
import "@/assets/moment-focus.css"
import IframeVideoPlayer from "@/components/shared/IframeVideoPlayer.vue"
import { VideoType } from "@/models/VideoType"
import VueSocialSharing from "vue-social-sharing"
import { setupSocialShare } from "@/composables/social-share"
const AmplilyWidget = defineComponent({
  components: { VideoPlayer, InfoTab, FullVideoCompoment, IframeVideoPlayer },
  props: {
    fetchId: { type: String, required: true }
  },
  setup() {
    let webinarId = ref(-1)
    let webinarInfo = ref<WebinarInfo | null>(null)
    let loadingmsg = ref("Loading video...")
    const globalData = injectStrict(GlobalDataKey).value
    const themeCss = computed(() => {
      let color = new Color(globalData.theme_data.theme_color)
      color.a = 0.4
      return {
        "--font-color": globalData.theme_data.font_color,
        "--font-size": globalData.theme_data.font_size + "pt", //default is 11pt
        "--font-family": globalData.theme_data.font_family,
        "--theme-color": globalData.theme_data.theme_color,
        "--theme-contrast": color.islight() ? `#000000` : `#ffffff`,
        "--theme-contrast-brightness": color.islight()
          ? `rgba(0,0,0,0.2)`
          : `rgba(255,255,255,0.2)`,
        "--font-size-22":
          (globalData.theme_data.font_size + 11).toString() + "pt",
        "--font-size-12":
          (globalData.theme_data.font_size + 1).toString() + "pt",
        "--font-size-14":
          (globalData.theme_data.font_size + 3).toString() + "pt",
        "--font-size-18":
          (globalData.theme_data.font_size + 7).toString() + "pt",
        "--colored-playicon": `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M8 5v14l11-7z' fill='${
          color.islight() ? `%23000000` : `%23ffffff`
        }'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E")`
      }
    })
    const dataService = container.resolve(WebinarDataService)
    const analytics = container.resolve(AnalyticsClient)
    let logger = injectStrict(LoggerKey)
    let socialShareUrl = ref(globalData.socialShareUrl)
    var app = getCurrentInstance()
    if (!app) throw new Error("app cannot be null")
    app.appContext.app.use(VueSocialSharing)
    const { registerSocialShare } = setupSocialShare()
    return {
      socialShareUrl,
      logger,
      dataService,
      webinarInfo,
      themeCss,
      globalData,
      webinarId,
      loadingmsg,
      analytics,
      VideoType,
      registerSocialShare
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.dataService.getData(this.fetchId).then(async returnValue => {
        this.loadingmsg = "Couldn't load the video."
        if (returnValue == undefined) {
          this.logger!.error(`Parmonic Widget error: Webinar not found`)
          return
        }
        this.webinarInfo = returnValue as WebinarInfo
        this.webinarId = this.webinarInfo.id
        setThemeData(this.webinarInfo.theme_data, this.globalData)
        this.analytics.setUp(
          this.webinarId,
          this.globalData.analyticsEventsCaptureEndPoint,
          this.logger
        )
        var event: AwEventStore = { eventType: AwEventType.WebinarViewed }
        this.analytics.register(event)
        getFullVideo(this.webinarInfo).then(returnValue => {
          this.globalData.fullVideoInfo = returnValue
        })
        setTimeout(focusOnMoment, 500)
      })
    }
  }
})
export default AmplilyWidget
</script>
